export enum SlotGameState
{
	Loading = "Loading",
	Idle = "Idle",
	WaitGameStart = "WaitGameStart",
	Spin = "Spin",
	BonusMultiplier = "BonusMultiplier",
	FillingPot = "FillingPot",
	Features = "Features",
	Scatter = "Scatter",
	BigWinBasegame = "BigWinBasegame",
	Win = "Win",
	WaitBonusStartConfig = "WaitBonusStartConfig",
	BonusTrigger = "BonusTrigger",
	Bonus = "Bonus",
	Exit = "Exit",
	// = "//" after bonus, check if we start coin fountain
	BigWinTotal = "BigWinTotal",
	
	WaitCollect = "WaitCollect",
	Collect = "Collect",
	
	GameFinished = "GameFinished",
	DoubleState = "DoubleState",
}